export default __webpack_public_path__ + "static/media/LoginLogo.ac782d0d.svg";